import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import PersonalStory from "./components/PersonalStory";
import DayInLife from "./components/DayInLife";
import TechnicalPhilosophy from "./components/TechnicalPhilosophy";
import WorkingWithMe from "./components/WorkingWithMe";
import PersonalityTraits from "./components/PersonalityTraits";
import { Link } from "react-router-dom";

const AboutUniverse = () => {
  const [activeSection, setActiveSection] = useState("story");
  const [isVisible, setIsVisible] = useState(false);

  const sections = [
    // { id: 'story', label: 'My Story', icon: 'User', component: PersonalStory },
    // { id: 'day', label: 'Day in Life', icon: 'Clock', component: DayInLife },
    // { id: 'philosophy', label: 'Philosophy', icon: 'Brain', component: TechnicalPhilosophy },
    // { id: 'working', label: 'Working Style', icon: 'Users', component: WorkingWithMe },
    // { id: 'personality', label: 'Personality', icon: 'Heart', component: PersonalityTraits }
  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const ActiveComponent =
    sections?.find((section) => section?.id === activeSection)?.component ||
    PersonalStory;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Hero Section */}
      <section className="pt-24 pb-16 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
            transition={{ duration: 0.8 }}
            className="text-center space-y-6 mb-16"
          >
            <div className="inline-flex items-center space-x-2 bg-conversion-accent/10 text-conversion-accent px-4 py-2 rounded-full text-sm font-medium">
              <Icon name="Sparkles" size={16} />
              <span>About Universe</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-foreground">
              Beyond the <span className="text-conversion-accent">Code</span>
            </h1>

            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Meet the developer behind the designs, the ideas behind the code,
              the passion that drives every line of code I write.
            </p>
          </motion.div>

          {/* Navigation Tabs */}
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex justify-center mb-12"
          >
            <div className="bg-card/50 backdrop-blur-sm border border-border rounded-xl p-2 flex flex-wrap gap-2 max-w-4xl">
              {sections?.map((section) => (
                <button
                  key={section?.id}
                  onClick={() => setActiveSection(section?.id)}
                  className={`flex items-center space-x-2 px-4 py-3 rounded-lg transition-smooth ${
                    activeSection === section?.id
                      ? 'bg-conversion-accent text-white shadow-lg'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }`}
                >
                  <Icon name={section?.icon} size={18} />
                  <span className="font-medium">{section?.label}</span>
                </button>
              ))}
            </div>
          </motion.div> */}

          {/* Content Section */}
          <motion.div
            key={activeSection}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-6xl mx-auto"
          >
            <ActiveComponent />
          </motion.div>
        </div>
      </section>
      {/* Call to Action */}
      <section className="py-16 px-6 lg:px-8 bg-gradient-to-r from-conversion-accent/5 via-trust-builder/5 to-cta/5">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h2 className="text-3xl font-bold text-foreground">
              Ready to Work Together?
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Now that you know more about me, let's explore how we can create
              something amazing together. Check out my projects or get in touch
              to start a conversation.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link to="/project-showcase-gallery">
              <button className="inline-flex items-center justify-center px-8 py-4 bg-conversion-accent hover:bg-conversion-accent/90 text-white font-semibold rounded-lg transition-smooth shadow-lg hover:shadow-xl">
                <Icon name="FolderOpen" size={20} className="mr-2" />
                View My Projects
              </button>
            </Link>

            <Link to="/contact">
              <button className="inline-flex items-center justify-center px-8 py-4 bg-card hover:bg-card/80 text-foreground font-semibold rounded-lg border border-border hover:border-conversion-accent/30 transition-smooth">
                <Icon name="MessageCircle" size={20} className="mr-2" />
                Let's Connect
              </button>
            </Link>
          </motion.div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 px-6 lg:px-8 border-t border-border">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-br from-conversion-accent to-trust-builder rounded-lg flex items-center justify-center">
                <Icon name="Code2" size={16} color="white" />
              </div>
              <span className="font-semibold text-foreground">Yash Pal</span>
            </div>

            <div className="flex items-center space-x-6">
              <a
                href="https://github.com/Yashya14"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="text-muted-foreground hover:text-conversion-accent transition-smooth">
                  <Icon name="Github" size={20} />
                </button>
              </a>
              <a
                href="https://linkedin.com/in/yash-gajanan-pal"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="text-muted-foreground hover:text-conversion-accent transition-smooth">
                  <Icon name="Linkedin" size={20} />
                </button>
              </a>
              {/* <button className="text-muted-foreground hover:text-conversion-accent transition-smooth">
                <Icon name="Twitter" size={20} />
              </button> */}
            </div>

            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} Yash Pal. Crafted with ❤️ and
              passion.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutUniverse;
